import { render, staticRenderFns } from "./SearchResultNewsListItem.vue?vue&type=template&id=54b5e982&scoped=true"
import script from "./SearchResultNewsListItem.vue?vue&type=script&lang=js"
export * from "./SearchResultNewsListItem.vue?vue&type=script&lang=js"
import style0 from "./SearchResultNewsListItem.vue?vue&type=style&index=0&id=54b5e982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b5e982",
  null
  
)

export default component.exports